export default __webpack_public_path__ + "static/media/a2-4-13.3db02eba.jpg";